import { render } from "./ui-text-editor.vue?vue&type=template&id=f590d8dc"
import script from "./ui-text-editor.vue?vue&type=script&lang=js"
export * from "./ui-text-editor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__